<agr-page-toolbar
  [isEmpty]="!leeOAuthenticationTableConfig || !hasData"
  [emptyTitle]="'settings.third-parties.no-lee-o-authentication-title' | translate"
  [emptyDescription]="'settings.third-parties.lee-o-upload-information-message' | translate"
  [emptyActionText]="'settings.third-parties.add-authentication' | translate"
  [showEmptyAction]="!hasData"
  emptyImage="assets/images/pigs_001.jpg"
  emptyActionIcon="cloud_upload"
  (emptyAction)="handleAddApiToken()"
  data-test="lee-o-overview"
>
  <div class="spacing--margin-all">
    <h2>{{ 'settings.third-parties.lee-o-authentication-title' | translate }}</h2>
    <agr-table
      *ngIf="(isLoading$ | async) === false && leeOAuthenticationTableConfig && hasData"
      [config]="leeOAuthenticationTableConfig"
      data-test="lee-o-installations-table"
    >
    </agr-table>
  </div>
  <ng-template #statusTemplate let-row="row">
    <ng-container *ngIf="row.status === 'Authenticated'; else unauthenticated">{{
      'settings.third-parties.authenticated' | translate
    }}</ng-container>
    <ng-template #unauthenticated
      >{{ 'settings.third-parties.unauthenticated' | translate }}
    </ng-template>
  </ng-template>
</agr-page-toolbar>
